export function decodeExp(jwt: string): number | null {
  const parts = jwt.split('.');
  if (parts.length !== 3) return null;
  const payloadPart = parts[1];
  if (!payloadPart) return null;
  try {
    const payload = JSON.parse(atob(payloadPart.replace(/-/g, '+').replace(/_/g, '/'))) as Record<
      string,
      unknown
    >;
    const exp = payload.exp;
    return typeof exp === 'number' ? exp : null;
  } catch {
    return null;
  }
}

export function isNearExpiry(jwt: string, skewSec: number): boolean {
  const exp = decodeExp(jwt);
  if (exp === null) return false;
  return exp * 1000 - Date.now() <= skewSec * 1000;
}
